import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { RoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/outputs/role.model';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as css from '../role.module.scss';

interface RoleDetailsViewProps {
  role: RoleModel;
}

export const RoleDetailsView = ({
  role,
}: RoleDetailsViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  // Nothing to do

  // HANDLERS //////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <div className={css.roleDetails}>
      <Card>
        <AccentTitle
          icon="map-01"
          text={t('$.role-details.information')}
          variant={AccentVariantEnum.Primary}
        />
        <div className={css.cardContent}>
          <p>
            <span>{t('delmonicos-shared-sdk.outputs-base.id')} : </span>
            {role.id}
          </p>
          <p>
            <span>
              {t('delmonicos-shared-sdk.outputs-role-template.name')} :{' '}
            </span>
            {role.name}
          </p>
        </div>
      </Card>
    </div>
  );
};
